/* /src/components/auth/logout.jsx */

import React, { useContext, useEffect } from "react";
import { AppContext } from "../../providers/appProvider";
import Typography from "@material-ui/core/Typography";

export const Logout = () => {
    const { logout } = useContext(AppContext);

    useEffect(() => {
        logout();
    }, [logout]);

    return (
        <Typography align="center" style={{padding: 32, display: "block", width: "100%"}}>
            Завантаження...
        </Typography>
    );
};
